var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg-icon',_vm._g({attrs:{"name":_vm.name,"fill":_vm.isFilled,"scale":_vm.scale}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }